import { useTranslation } from 'react-i18next';

import { IconButton } from '@hotjar/hotsauce';

export interface CloseButtonProps {
  className?: string;
  onClose: () => void;
}

export function CloseButton({ className, onClose }: CloseButtonProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <IconButton
      className={className}
      icon="close"
      kind="ghost"
      onClick={onClose}
      size="s"
      tooltipText={t('highlights:single.close')}
    />
  );
}
